const initialState = {
  clientFormConfig: null
};

export const publicReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CLIENT_FORM_CONFIG':
      return { ...state, clientFormConfig: action.data };
    default:
      return state;
  }
}
